import React from 'react';
import '../../styles/RateCard.css';

const ContextualArticles = () => {
    return (
        <section className="contextual-articles-section py-5" id='contextual-articles'>
            <div className="container">
                <div className="row gx-5">

                    {/* Columna Izquierda */}
                    <div className="col-md-6 bg-dark-teal text-white p-5 rounded-start" data-aos="fade-right" data-aos-delay="200">
                        <h2 className="title text-white text-capitalize">
                            Artículos <br /> <span className="highlight-bg">Contextuales</span>
                        </h2>
                        <p className="mt-4">
                            El contenido es redactado por nuestro equipo editorial y enfocado en temas relevantes para tu marca.
                            Estos artículos están diseñados para brindar valor a la audiencia mientras posicionan tu marca de forma exclusiva.
                            Además, están optimizados para SEO, asegurando un posicionamiento destacado en buscadores y una mayor visibilidad orgánica.
                        </p>
                        <ul className="mt-4 custom-bullets">
                            <li>Redacción profesional alineada con los objetivos de la marca.</li>
                            <li>Exclusividad en los espacios publicitarios asociados al contenido.</li>
                            <li>Optimización SEO para posicionar el artículo en búsquedas relacionadas.</li>
                            <li>Incremento en la visibilidad y credibilidad de la marca.</li>
                        </ul>
                        <div className="tab-label mt-4">Contenido</div>
                    </div>

                    {/* Columna Derecha */}
                    <div className="col-md-6 bg-light-green p-5 rounded-end position-relative"  data-aos="fade-left" data-aos-delay="200">

                        <div className='d-flex justify-content-center'>
                            <div className='position-relative z-0'>
                                <h3 className="subtitle-rate-card fw-bold text-center">Características</h3>

                                <div className='position-absolute top-100 start-50 translate-middle'>
                                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#056059" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                                </div>
                            </div>
                        </div>
                        <div className='reach mt-3 rounded p-3'>
                            <h4>Alcance:</h4>
                            <p className="">
                                Un nuevo artículo de contenido en BeHealth recibe 1.000 visitas (en promedio) durante el 1er mes.
                            </p>
                        </div>
                        <div className="includes-box">
                            <div className='shadow-lg rounded p-4 mt-3'>
                                <h5 className="fw-bold text-teal">Incluye:</h5>
                                <ul className="ps-3 mt-2">
                                    <li>Réplica orgánica en RRSS con @mención.</li>
                                    <li>Link desde el Home garantizado × 1 día.</li>
                                    <li>Link en Categoría especial garantizado × 1 Mes.</li>
                                    <li>Paid Media en públicos exclusivos para más tráfico.</li>
                                </ul>
                            </div>
                        </div>

                        <div className='w-100 d-flex justify-content-center'>
                            <div className="investment-box bg-teal text-white p-3 mt-4 rounded shadow-lg">
                                <strong>Inversión:</strong><br />
                                A cotizar x artículo.
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default ContextualArticles;
